import { useState, useEffect, useMemo } from 'react';
import { useTable, usePagination, useSortBy, useFilters } from 'react-table'

import ReactLoading from 'react-loading';

import dayjs from 'dayjs';

import "react-datepicker/dist/react-datepicker.css";

import DataTableDrawer from '../components/Drawers/DataTableDrawer.js';
import FilterCard from '../components/Dashboard/FilterCard.js';

import { useTranslation } from "react-i18next";

import { CSVLink } from "react-csv";

import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import TuneIcon from '@mui/icons-material/Tune';
import ClearIcon from '@mui/icons-material/Clear';

import {
  handleDayTypeClick,
  handleMultiPeriodClick,
  handleMultiRoutes,
  checkFilterCookies,
  updateFilterCookies,
  deleteFilterCookies
} from '../helpers/filterHelpers.js'

import {
  getUser,
  getUserAgency,
  getAllAgencies,
  getDataReport,
  getRoutes
} from '../API';

import styled from 'styled-components'


const Styles = styled.div
  `
  padding: 1rem;

  .pagination {
    padding: 0.5rem;
  }

  th

  td { background-color: white; }
`

function Table({ columns, data }) {

  const [t] = useTranslation('common');

  const [selectedRow, setSelectedRow] = useState(-1);

  // const [filterInput, setFilterInput] = useState("");

  // const handleFilterChange = e => {
  //   const value = e.target.value || undefined;
  //   setFilter("route_id", value); // Update this specific field
  //   setFilterInput(value);
  // };

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active pagconst [cellValue, setCellValue] = useState('');e

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 25 },

      sortTypes: {
        custom: (rowA, rowB, columnId) => {
          const a = rowA.values[columnId];
          const b = rowB.values[columnId];

          if (!isNaN(Number(a)) && !isNaN(Number(b))) {
            return Number(a) - Number(b);
          }
          return a.localeCompare(b);
        }
      },
    },
    useSortBy,
    usePagination,
  )

  const handleRowHover = (e) => {
    setSelectedRow(e.id);
  }

  const handleMouseOut = () => {
    setSelectedRow(-1);
  }

  // const handleCellClick = (e) => {

  // }

  // Render the UI for your table
  return (

    <>
      <table className="table" {...getTableProps()}>
        <thead style={{ textAlign: 'center' }}>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {

            prepareRow(row);

            return (
              <tr
                onMouseMove={(e) => handleRowHover(row)} onMouseOut={() => handleMouseOut()}
                {...row.getRowProps()}
              >
                {row.cells.map(cell => {
                  return <td
                    style={{ backgroundColor: row.id == selectedRow && cell.column.Header !== 'Ligne' ? '#D3D3D3' : '' }}
                    {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} {t('routeoperation.of')} {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | {t("routeoperation.go")}{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[25, 50, 100].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              {t("routeoperation.show")} {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}



const DataTable = () => {

  const [t] = useTranslation('common');

  //Table Data
  const [tableData, setTableData] = useState([]);

  const columns = useMemo(
    () => {
      const result = [
        {
          Header: <div>{t('datatable.table.pkm1')} <br /><div>{t('datatable.table.pkm2')}</div></div>,
          accessor: 'plankm',
          Cell: props => <div> {parseFloat(props.value).toFixed(0)} </div>,
        },
        {
          Header: <div>{t('datatable.table.rkm1')} <br /><div>{t('datatable.table.rkm2')}</div></div>,
          accessor: 'realkm',
          Cell: props => <div> {parseFloat(props.value).toFixed(0)} </div>,
        },
        {
          Header: <div>{t('datatable.table.ph1')} <br /><div>{t('datatable.table.ph2')}</div></div>,
          accessor: 'planduration',
          Cell: props => <div> {parseFloat(props.value).toFixed(0)} </div>,
        },
        {
          Header: <div>{t('datatable.table.rh1')} <br /><div>{t('datatable.table.rh2')}</div></div>,
          accessor: 'realduration',
          Cell: props => <div> {parseFloat(props.value).toFixed(0)} </div>,
        },
        {
          Header: <div>{t('datatable.table.otp')}</div>,
          accessor: 'otp',
          Cell: props => <div> {parseFloat(props.value).toFixed(1)} </div>,
        },
        {
          Header: <div>{t('datatable.table.occ')}</div>,
          accessor: 'occ',
          Cell: props => <div> {parseFloat(props.value).toFixed(1)} </div>,
        },

      ];

      let keys = tableData[0] ? Object.keys(tableData[0]) : '';

      if (keys !== '') {

        if (keys.find((e) => e == 'days') == 'days') {
          result.unshift({
            Header: <div>{t('datatable.days')}</div>,
            accessor: 'days',
          });
        }

        if (keys.find((e) => e == 'period') == 'period') {
          result.unshift({
            Header: <div>{t('datatable.period')}</div>,
            accessor: 'period',
          });
        }

        if (keys.find((e) => e == 'direction_id') == 'direction_id') {
          result.unshift({
            Header: <div>Direction</div>,
            accessor: 'direction_id',
          });
        }

        if (keys.find((e) => e == 'route_id') == 'route_id') {
          result.unshift({
            Header: <div>{t('datatable.route')}</div>,
            accessor: 'route_id',
          });
        }

        if (keys.find((e) => e == 'date') == 'date') {
          result.unshift({
            Header: <div>{t('datatable.day')}</div>,
            accessor: 'date',
          });
        }

        if (keys.find((e) => e == 'week') == 'week') {
          result.unshift({
            Header: <div>{t('datatable.week')}</div>,
            accessor: 'week',
          });
        }

        if (keys.find((e) => e == 'month') == 'month') {
          result.unshift({
            Header: <div>{t('datatable.month')}</div>,
            accessor: 'month',
          });
        }

        if (keys.find((e) => e == 'year') == 'year') {
          result.unshift({
            Header: <div>{t('datatable.year')}</div>,
            accessor: 'year',
          });
        }

      }

      return result;

    }, [tableData]
  )


  const [user, setUser] = useState('');

  const [agencies, setAgencies] = useState('');
  const [agency, setAgency] = useState('');
  const [userAgency, setUserAgency] = useState('');
  const [loading, setLoading] = useState(0);

  //Reference Dates
  const [startDate, setStartDate] = useState(new Date().setDate(new Date().getDate() - 1));
  const [endDate, setEndDate] = useState(new Date());
  const [startFormat, setStartFormat] = useState('2023-01-01');
  const [endFormat, setEndFormat] = useState(dayjs().format('YYYY-MM-DD'));

  const [refreshKey, setRefreshKey] = useState(0);

  //Filters
  //const [service, setService] = useState(checkFilterCookies()[0].service ? checkFilterCookies()[0].service : 'tous');
  const [service, setService] = useState('tous');
  //const [period, setPeriod] = useState(checkFilterCookies()[0].period ? checkFilterCookies()[0].period : ['all']);
  const [period, setPeriod] = useState(['all']);
  //const [selectedRoutes, setSelectedRoutes] = useState(checkFilterCookies()[0].route ? checkFilterCookies()[0].route : ['all']);
  const [selectedRoutes, setSelectedRoutes] = useState(['all']);
  const [routes, setRoutes] = useState('');

  const [agg, setAgg] = useState('year');
  const [dataType, setDataType] = useState('total');
  const [params, setParams] = useState([]);

  const [routeChecked, setRouteChecked] = useState(false);
  const [directionChecked, setDirectionChecked] = useState(false);
  const [periodChecked, setPeriodChecked] = useState(false);
  const [daysChecked, setDaysChecked] = useState(false);

  //Filter cards
  const [refStartV, setRefStartV] = useState('');
  const [refEndV, setRefEndV] = useState('');

  const [serviceV, setServiceV] = useState('');
  const [periodV, setPeriodV] = useState('');
  const [routesV, setRoutesV] = useState('');

  //Notifications
  const [error, setError] = useState(false);

  //Drawer
  const [open, setOpen] = useState(false);


  //Translate filters from cookies
  useEffect(() => {

    let serviceCookie = checkFilterCookies()[0].service;
    let periodCookie = checkFilterCookies()[0].period;
    let routesCookie = checkFilterCookies()[0].route;

    //Set card value for service
    if (serviceCookie && (serviceCookie == 'tous' || serviceCookie == 'all' || serviceCookie == t('compareperiods.all'))) {
      setServiceV(t('compareperiods.all'))
    } else if (serviceCookie && (serviceCookie == 'se' || serviceCookie == t('compareperiods.week'))) {
      setServiceV(t('compareperiods.week'))
    } else if (serviceCookie && (serviceCookie == 'fds' || serviceCookie == t('compareperiods.weekends'))) {
      setServiceV(t('compareperiods.weekends'))
    } else {
      setServiceV(t('compareperiods.all'))
    }

    //Set card value for period
    let periodFormat = [];

    if (periodCookie && typeof periodCookie !== 'string') {
      periodCookie.forEach((e) => {
        switch (e) {
          case 'all':
            periodFormat.push(' ' + t('compareperiods.all'));
            break
          case 'morning':
            periodFormat.push(' ' + t('compareperiods.morning'));
            break
          case 'am':
            periodFormat.push(' ' + t('compareperiods.am'));
            break
          case 'offpeak':
            periodFormat.push(' ' + t('compareperiods.offpeak'));
            break
          case 'pm':
            periodFormat.push(' ' + t('compareperiods.pm'));
            break
          case 'evening':
            periodFormat.push(' ' + t('compareperiods.evening'));
            break
        }
      })
    } else if (periodCookie) {
      switch (periodCookie) {
        case 'all':
          periodFormat.push(' ' + t('compareperiods.all'));
          break
        case 'morning':
          periodFormat.push(' ' + t('compareperiods.morning'));
          break
        case 'am':
          periodFormat.push(' ' + t('compareperiods.am'));
          break
        case 'offpeak':
          periodFormat.push(' ' + t('compareperiods.offpeak'));
          break
        case 'pm':
          periodFormat.push(' ' + t('compareperiods.pm'));
          break
        case 'evening':
          periodFormat.push(' ' + t('compareperiods.evening'));
          break
      }
    } else {
      periodFormat = t('compareperiods.all')
    }

    setPeriodV(periodFormat);

    //Set card value for routes
    setRoutesV(routesCookie && routesCookie.includes('all') ? t('compareperiods.all') :
      selectedRoutes == 'all' || selectedRoutes == t('compareperiods.all') ? t('compareperiods.all') :
        selectedRoutes);

  }, [])


  useEffect(() => {

    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })
    getUser()
      .then(response => {
        setUser(response.user);
      })
    getUserAgency().then(response => {
      setUserAgency(response)
    })
    getRoutes(agency)
      .then(response => {
        setRoutes(response);
      });

  }, []);


  const getData = () => {
    if (selectedRoutes.length > 0) {
      setLoading(1);
      getDataReport(agency, params, agg, period, dataType, service, selectedRoutes, startFormat, endFormat)
        .then((response) => {
          setTableData(response)
          setLoading(0);
        })
    }
  }


  const handleChangeStartRange = (date) => {
    setStartDate(date);
    let formatstart = dayjs(date).format('YYYY-MM-DD');
    setStartFormat(formatstart);
  }

  const handleChangeEndRange = (date) => {
    setEndDate(date);
    let formatend = dayjs(date).format('YYYY-MM-DD');
    setEndFormat(formatend);
  }


  function handleAgencySelect(e) {
    setAgency(e.target.value);
  }

  const handleToggle = () => {
    setOpen(!open)
  };

  const clearFilters = () => {

    setStartDate(new Date().setDate(new Date().getDate() - 1));
    setEndDate(null);
    setStartFormat('2023-01-01');
    setEndFormat(dayjs().format('YYYY-MM-DD'));

    setPeriod('all');
    setService('tous');
    setSelectedRoutes([]);

    setAgg('year');
    setDataType('total');
    setParams([]);

    setRouteChecked(false);
    setDirectionChecked(false);
    setPeriodChecked(false);
    setDaysChecked(false);

    setTableData([]);

    setRefStartV('2023-01-01');
    setRefEndV(dayjs().format('YYYY-MM-DD'));
    setServiceV(t('compareperiods.all'));
    setPeriodV(t('compareperiods.all'));
    setRoutesV(t('compareperiods.all'));

    //setRefreshKey(oldKey => oldKey + 1);
    deleteFilterCookies();

  };


  const handleAggType = (e) => {
    if (e.target.innerHTML == t('datatable.year')) {
      setAgg("year")
    } else if (e.target.innerHTML == t('datatable.month')) {
      setAgg("month")
    } else if (e.target.innerHTML == t('datatable.week')) {
      setAgg("week")
    } else {
      setAgg("day")
    }
  }


  const handleDataType = (e) => {
    if (e.target.innerHTML == 'Total') {
      setDataType("total")
    } else {
      setDataType("avg")
    }
  }


  const handleParams = (e) => {

    //Handle option availability
    const { name, checked } = e.target;

    if (name === 'days') {
      setDaysChecked(checked);
    } else if (name === 'period') {
      setPeriodChecked(checked);
    } else if (name === 'route') {
      setRouteChecked(checked);
      if (!checked) {
        setDirectionChecked(false); // Uncheck direction when route is unchecked
      }
    } else if (name === 'direction') {
      setDirectionChecked(checked);
      if (checked && !routeChecked) {
        setRouteChecked(true); // Automatically check route when direction is checked
      }
    }

    //Handle array update
    const param = e.target.labels[0].innerText;

    const currentIndex = params.indexOf(param);
    const newSelectedOptions = [...params];

    if (currentIndex === -1) {
      newSelectedOptions.push(param);
    } else if (currentIndex !== -1 && param == t('datatable.route')) {
      newSelectedOptions.splice(0, newSelectedOptions.length);
    } else {
      newSelectedOptions.splice(currentIndex, 1);
    }

    setParams(newSelectedOptions);
  }


  const handleFilters = () => {

    //Handle filter visual updates
    setRefStartV(startFormat);
    setRefEndV(endFormat);

    //Translate service filter box
    setServiceV(service == 'tous' ? t('compareperiods.all') :
      service == 'se' ? t('compareperiods.week') :
        t('compareperiods.weekends'));

    //Translate period filter box
    let periodFormat = [];

    if (period !== 'all' && period.includes('all') == false) {
      period.forEach((e) => {
        switch (e) {
          case 'morning':
            periodFormat.push(' ' + t('compareperiods.morning'));
            break
          case 'am':
            periodFormat.push(' ' + t('compareperiods.am'));
            break
          case 'offpeak':
            periodFormat.push(' ' + t('compareperiods.offpeak'));
            break
          case 'pm':
            periodFormat.push(' ' + t('compareperiods.pm'));
            break
          case 'evening':
            periodFormat.push(' ' + t('compareperiods.evening'));
            break
        }
      })
    } else {
      periodFormat.push(t('compareperiods.all'));
    }

    setPeriodV(periodFormat);

    setRoutesV(selectedRoutes.includes('all') || selectedRoutes == t('compareperiods.all') ? t('compareperiods.all') : selectedRoutes);

    //Update filter cookies
    updateFilterCookies(service, period, selectedRoutes);

    getData();

  }


  return user && userAgency && agencies && routes ? (

    <>

      <div className="row justify-content-center ps-1 pe-1">
        <div className="col-sm">
          <h1 id="page-title" className="display-5">{t('datatable.title')}</h1>
          {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
            <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
          </div> : ''}
        </div>
      </div>

      <div className="container pb-2" style={{ backgroundColor: "#f8f9fa" }}>

        <DataTableDrawer
          toggle={handleToggle}
          open={open}

          //handleChangeDate={handleChangeDate}
          handleChangeStartRange={handleChangeStartRange}
          handleChangeEndRange={handleChangeEndRange}

          selected={startDate}
          startDate={startDate}
          endDate={endDate}

          service={service}
          handleDayTypeClick={handleDayTypeClick}

          period={period}
          handleMultiPeriodClick={handleMultiPeriodClick}

          routes={routes}
          selectedRoutes={selectedRoutes}
          setSelectedRoutes={setSelectedRoutes}
          handleMultiRoutes={handleMultiRoutes}

          setService={setService}
          setPeriod={setPeriod}

          agg={agg}
          handleAggType={handleAggType}

          dataType={dataType}
          handleDataType={handleDataType}

          params={params}
          handleParams={handleParams}

          routeChecked={routeChecked}
          directionChecked={directionChecked}
          periodChecked={periodChecked}
          daysChecked={daysChecked}

          handleFilters={handleFilters}
          error={error}
          t={t}
        />

        <div className="row justify-content-center pt-3">
          <div className="col-lg col-sm-12 text-center">

            {Array.isArray(userAgency) && userAgency.length > 1 ?
              <div className="me-1 border rounded ps-2 pe-2" style={{ backgroundColor: "white" }}>
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-sm-12">
                    <select onChange={(e) => handleAgencySelect(e)} className="form-select form-select-lg mb-3 mt-3">
                      <option defaultValue>Opérateur</option>
                      {userAgency.map((e) => (
                        <option value={e} key={e}
                        >{e}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              : ''}

          </div>
        </div>

        <div className="me-1 border rounded ps-2 pe-2" style={{ backgroundColor: "white" }}>

          <div className="row row-cols-1 row-cols-md-3 g-4 pb-3 justify-content-center">

            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={refStartV}
                kpi2={refEndV}
                desc={t('compareperiods.dates')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={serviceV}
                kpi2={''}
                desc={t('compareperiods.days')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={periodV !== t('compareperiods.all') ? periodV.join(',') : periodV}
                kpi2={''}
                desc={t('compareperiods.period')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={(routesV.length == routes.length || routesV.includes(t('compareperiods.all')) || selectedRoutes == 'all') ? t('compareperiods.all') : (routesV.length < 10 && routesV.length > 0 && routesV.includes(t('compareperiods.all')) == false) ? routesV.join(',') : t('compareperiods.custom')}
                kpi2={''}
                desc={t('compareperiods.routes')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2 text-center">
            <ButtonGroup orientation="vertical" aria-label="Vertical button group">
                <Button
                  variant="outlined"
                  onClick={handleToggle}
                  disableElevation
                  startIcon={<TuneIcon />}
                  //sx={ { borderRadius: 28 } }
                  style={{ fontWeight: "bold", borderColor: "#dee2e6", backgroundColor: "grey", color: "white" }}>
                  {t('compareperiods.filters')}
                </Button>
                <Button
                  variant="outlined"
                  onClick={clearFilters}
                  disableElevation
                  startIcon={<ClearIcon />}
                  //sx={ { borderRadius: 28 } }
                  style={{ fontWeight: "bold", borderColor: "#dee2e6", backgroundColor: "red", color: "white" }}>
                  {t('compareperiods.clear')}
                </Button>
                </ButtonGroup>
            </div>
          </div>

        </div >

        {loading == 0 ? '' :
          <div className="datatablespinner">
            <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
          </div>}



        {tableData.length > 0 ?
          <div className="row">
            <div className="pt-2">
              <h3 className="text-center pt-2 pb-2">{t("datatable.extracted")}</h3>
              <div className="ms-1 me-1 text-end">
                <CSVLink className="downloadbtn" filename="data-extract.csv" data={tableData}>
                  {t('datatable.export')}
                </CSVLink>
              </div>
              <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
                <div id="overflow-table" className="container">
                  <div className="row justify-content-center">
                    <div className="col">
                      <Styles>
                        <Table columns={columns} data={tableData} />
                      </Styles>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> : ''}

      </div >

    </>
  ) :
    <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="d-flex justify-content-center">
        <div className="row">
          <div className="col-sm">
            <h1 className="display-5">{t('data.loading')}</h1>
            <div className="d-flex justify-content-center">
              <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
            </div>
          </div>
        </div>
      </div>
    </div>
}
export default DataTable;